// i18n keys of the multi-tenant work package "monthlyflag" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  mf_service_flag: 'Monthly accounting service',
  mf_service_flag_hint: 'An invoice that carries this service opens its email on the monthly fee request; any other invoice opens on the payment request. Either can be switched in the email editor.',
  mf_tpl_label: 'Email template',
  mf_tpl_monthly: 'Monthly fee request',
  mf_tpl_payreq: 'Payment request',
  mf_tpl_default: 'default',
  mf_tpl_switch_hint: 'The default comes from the service catalogue (Monthly accounting service). Switching reloads the draft: sender, recipients, subject and body are filled in again.',
};
export const zh: Record<string, string> = {
  mf_service_flag: '月度会计服务',
  mf_service_flag_hint: '含有此服务的发票，发邮件时默认使用月度服务费请款模板；其他发票默认使用付款请求模板。两者都可以在邮件编辑页切换。',
  mf_tpl_label: '邮件模板',
  mf_tpl_monthly: '月度服务费请款',
  mf_tpl_payreq: '付款请求',
  mf_tpl_default: '默认',
  mf_tpl_switch_hint: '默认模板由服务目录（月度会计服务）决定。切换会重新生成草稿：发件人、收件人、主题和正文都会重新填写。',
};
export const th: Record<string, string> = {
  mf_service_flag: 'บริการบัญชีรายเดือน',
  mf_service_flag_hint: 'ใบแจ้งหนี้ที่มีบริการนี้จะเปิดอีเมลด้วยเทมเพลตเรียกเก็บค่าบริการรายเดือน ใบแจ้งหนี้อื่นจะเปิดด้วยเทมเพลตขอชำระเงิน เปลี่ยนได้ทั้งสองแบบในหน้าแก้ไขอีเมล',
  mf_tpl_label: 'เทมเพลตอีเมล',
  mf_tpl_monthly: 'เรียกเก็บค่าบริการรายเดือน',
  mf_tpl_payreq: 'ขอชำระเงิน',
  mf_tpl_default: 'ค่าเริ่มต้น',
  mf_tpl_switch_hint: 'ค่าเริ่มต้นมาจากแคตตาล็อกบริการ (บริการบัญชีรายเดือน) การเปลี่ยนจะสร้างร่างใหม่: ผู้ส่ง ผู้รับ หัวข้อ และเนื้อหาจะถูกกรอกใหม่ทั้งหมด',
};
